import { getAddressString, guardString } from "@msuite/utils/strings";
import { View } from "@react-pdf/renderer";
import React from "react";
import { useDocumentContext } from "../context";
import { tw } from "../tailwind";
import { Text } from "../text";

/** Props Interface */
interface AddressInformationProps {
	addressInformation: Array<string>;
}

export function AddressInformation({ addressInformation }: AddressInformationProps) {
	/** Context */
	const context = useDocumentContext();

	/** Render */
	return (
		<React.Fragment>
			<View>
				<Text style={tw("text-xs mb-2 underline")}>
					{guardString(context.workspaceMetadata?.companyName)} -{" "}
					{getAddressString(context.workspaceMetadata)}
				</Text>
				{addressInformation?.map((item) => (
					<Text key={item}>{item}</Text>
				))}
			</View>
		</React.Fragment>
	);
}
